import { helper } from '@ember/component/helper';

const COMPONENT_FIELD_MAP = {
  'teacher-comment': 'narrative',
  'next-steps': 'nextStepsDisplay',
  'help-at-home': 'homeHelp',
  'principal-comment': 'narrative',
};

/**
 * Looks up the student report section text for a given template section and component type.
 *
 * Usage: {{get-student-section-text sectionMap section "teacher-comment"}}
 */
export default helper(function getStudentSectionText([
  sectionMap,
  templateSection,
  componentType,
]) {
  if (!sectionMap || !templateSection || !componentType) return '';
  let sectionId = templateSection.get
    ? templateSection.get('id')
    : templateSection.id;
  let studentSection = sectionMap[sectionId];
  if (!studentSection) {
    return '';
  }
  let field = COMPONENT_FIELD_MAP[componentType];
  if (!field) {
    return '';
  }
  return studentSection.get(field) || '';
});
